export const backendCyclingProfiles = {
  BEGINNER: 'safe',
  EXPERT: 'direct',
  MEDIAN: 'daily',
  RIDE: 'touristic',
  VTC: 'hybridBike',
  VAE: 'eBike',
  CARGO: 'cargo',
  ROAD: 'road'
};
export const cyclingProfilesMap = {
  safe: 'BEGINNER',
  daily: 'MEDIAN',
  direct: 'EXPERT',
  touristic: 'RIDE',
  hybridBike: 'VTC',
  eBike: 'VAE',
  cargo: 'CARGO',
  road: 'ROAD'
};